import { z } from 'zod';

/** API may send `null` when no tooltip is defined. */
export const nullableTooltipSchema = z
  .string()
  .nullable()
  .optional()
  .transform((value) => value ?? undefined);

/** Request/response bodies keep null for explicit clear. */
export const nullableTooltipBodySchema = z.string().nullable();

export const staffStatColumnMetadataRowSchema = z.object({
  catalogId: z.string(),
  tooltip: nullableTooltipBodySchema,
  createdAt: z.string(),
  createdBy: z.string(),
  updatedAt: z.string(),
  updatedBy: z.string().nullable(),
});

export type StaffStatColumnMetadataRow = z.infer<typeof staffStatColumnMetadataRowSchema>;

export const staffStatColumnMetadataListSchema = z.object({
  items: z.array(staffStatColumnMetadataRowSchema),
});

export type StaffStatColumnMetadataList = z.infer<typeof staffStatColumnMetadataListSchema>;

export const upsertStaffStatColumnMetadataBodySchema = z
  .object({
    tooltip: nullableTooltipBodySchema,
  })
  .strict();

export const upsertStaffStatColumnMetadataBulkBodySchema = z
  .object({
    items: z
      .array(
        z
          .object({
            catalogId: z.string().min(1),
            tooltip: nullableTooltipBodySchema.optional(),
          })
          .strict(),
      )
      .min(1),
  })
  .strict();

export const upsertStaffStatColumnMetadataResponseSchema = z.object({
  item: staffStatColumnMetadataRowSchema.nullable(),
});

export type UpsertStaffStatColumnMetadataBulkBody = z.infer<
  typeof upsertStaffStatColumnMetadataBulkBodySchema
>;
